import {BulletinHoursListIdsRequest} from '../../../../infrastructure/remote/sacmi/dto/request/BulletinHoursListIdsRequest';
import {SummaryRepository} from '../repository/SummaryRepository';
import {
    SummaryListExportExcelResponse
} from "../../../../infrastructure/remote/sacmi/dto/response/SummaryListExportExcelResponse";

interface Props {
    summaryRepository: SummaryRepository;
    filters: BulletinHoursListIdsRequest;
}

export default async (props: Props): Promise<SummaryListExportExcelResponse> => {
    try {
        return await props.summaryRepository.exportExcel(props.filters);
    } catch (error) {
        return Promise.reject(error);
    }
}